import React from 'react';
import gql from 'graphql-tag';
import { RouteComponentProps } from 'react-router';
import { graphql, ChildProps } from 'react-apollo';

import MarketplacePageWrapper from './marketplace_page_wrapper';
import EmptyShop from '../discovery/empty_shop';

import { MarketplacePathContext } from '../shared/url_helpers';
import { CoreShopMarketplace } from '../../schemas/rql';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

type RouteProps = RouteComponentProps<MarketplacePathContext, {}>;

type Props = RouteProps & ChildProps<RouteProps, CoreShopMarketplace.Query, CoreShopMarketplace.Variables>;

export class ShopPage extends React.Component<Props, null> {
  renderEmptyShop() {
    if (!this.props.data.shop) {
      return null;
    }

    return (
      <EmptyShop
        location={this.props.location}
        shop={this.props.data.shop}
      />
    );
  }

  render() {
    const { showSold = false } = this.props.data.shop || {};

    return (
      <MarketplacePageWrapper
        emptyGrid={this.renderEmptyShop()}
        pageSettings={{
          showSold,
          useExperimentalRecall: false,
          useExperimentalBestMatchSignals: false,
        }}
        pageName={MParticlePageName.Shop}
      />
    );
  }
}

const connect = graphql<
RouteProps,
CoreShopMarketplace.Query,
CoreShopMarketplace.Variables
>(
  gql`
    query Core_Shop_Marketplace($shop: String) {
      shop(input: { slug: $shop }) {
        _id
        name
        id
        userId
        onVacation
        showSold
      }
    }
  `,
  {
    options: (props) => ({
      ssr: true,
      variables: {
        shop: props.params.shop,
      },
    }),
  },
);

export default connect(ShopPage);
